import { Collapse } from "antd";
import type React from "react";
import type { TProgressSummary } from "../../types/index.type";
import { formatDistanceFromInputDateTimeToNow } from "../../utils/datamanipulation.utils";
import ProgressSummaryView from "../ProgressSummaryView/ProgressSummaryView.component";
import styles from "./Superdoc.module.scss";

const SummaryIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
    <path
      d="M8 1.5C5 1.5 3 3.5 3 6.5C3 8 3.5 9 4 10L4 12.5C4 13 4.5 13.5 5 13.5L11 13.5C11.5 13.5 12 13 12 12.5L12 10C12.5 9 13 8 13 6.5C13 3.5 11 1.5 8 1.5Z"
      stroke="#6366F1"
      strokeWidth="1.3"
      fill="#EEF2FF"
    />
    <circle cx="8" cy="6.5" r="1.5" fill="#6366F1" />
  </svg>
);

interface ProgressSummaryPanelProps {
  summary: TProgressSummary;
  lastUpdatedAt?: string;
}

/**
 * Pinned, collapsible Progress Summary shown above the Superdoc chat
 * thread. Collapsed by default so the chat stays the focus; expands into
 * a height-capped scroll area. Replaces the old dedicated client page's
 * summary card now that the right pane is a single-note viewer.
 */
const ProgressSummaryPanel: React.FC<ProgressSummaryPanelProps> = ({ summary, lastUpdatedAt }) => {
  return (
    <div className={styles["superdoc__progress-summary"]}>
      <Collapse
        ghost
        items={[
          {
            key: "progress_summary",
            label: (
              <span className={styles["superdoc__progress-summary-label"]}>
                <SummaryIcon /> Progress Summary
              </span>
            ),
            extra: lastUpdatedAt ? (
              <span className={styles["superdoc__progress-summary-updated"]}>
                Updated {formatDistanceFromInputDateTimeToNow(lastUpdatedAt)}
              </span>
            ) : undefined,
            children: (
              <div className={styles["superdoc__progress-summary-body"]}>
                <ProgressSummaryView summary={summary} />
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default ProgressSummaryPanel;
